module.exports = __webpack_public_path__ + "media/application/images/blobs/blob_green-5ca819fee3f20d227cf57e9dbddd1c5a.png";